var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1680590769821,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 13054,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M959.5 768c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.6 12.8 44.3 31.9 55.3C859.7 864 825.6 896 784 896c-40.1 0-73.3-29.7-78.9-68.4 54.4-14.6 94.4-64.2 94.4-123.1V632c19.7-10.9 33-31.9 33-56 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.3 12.4 43.6 31 54.8v73.7c0 35.1-28.4 63.5-63.5 63.5s-63.5-28.4-63.5-63.5v-73.1c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.7 12.9 44.3 32 55.4v73.1c0 59.7 41.1 109.9 96.5 123.7C647.2 902 708.8 960 784 960c76.7 0 139.4-60.4 143.3-136.5 19.2-11 32.2-31.7 32.2-55.5zM641.4 256c0-17.7-14.3-32-31.9-32H226.1c-17.6 0-31.9 14.3-31.9 32s14.3 32 31.9 32h383.4c17.6 0 31.9-14.3 31.9-32zM641.4 448c0-17.7-14.3-32-31.9-32H226.1c-17.6 0-31.9 14.3-31.9 32s14.3 32 31.9 32h383.4c17.6 0 31.9-14.3 31.9-32zM226.1 608c-17.6 0-31.9 14.3-31.9 32s14.3 32 31.9 32h191.7c17.6 0 31.9-14.3 31.9-32s-14.3-32-31.9-32H226.1z",
    "p-id": 13055,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.8 832H160.2c-17.6 0-31.9-14.3-31.9-32V160c0-17.7 14.3-32 31.9-32h513.6c17.6 0 31.9 14.3 31.9 32v256c0 17.7 14.3 32 31.9 32 17.6 0 31.9-14.3 31.9-32V128c0-35.3-28.6-64-63.8-64H128.3c-35.2 0-63.8 28.7-63.8 64v704c0 35.3 28.6 64 63.8 64h353.5c17.6 0 31.9-14.3 31.9-32s-14.2-32-31.9-32z",
    "p-id": 13056,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistManagement);
export default __webpack_public_path__ + "static/media/checklistManagement.ffdecee5.svg";
export { ForwardRef as ReactComponent };